import React from 'react'
import { checkTextTranslation } from '../../utils/useful'

class EmptyInput extends React.Component {
    state = {
    }

    render() {
        return (
            <div className="w-100 h-100" style={{cursor:"none"}}>
            </div>
        )
    }
}

export default EmptyInput;